import React, { useState, useEffect, useContext } from 'react';
import { LuCalendarDays } from 'react-icons/lu';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext, { strings } from '../../contexts/language';
import api from '../../services/api';

export default function Agenda() {
    const { language } = useContext(LanguageContext);
    const t = strings[language] || strings.pt;
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.post('/events').then(r => {
            setEvents(r.data.content || []);
            setLoading(false);
        }).catch(() => setLoading(false));
    }, []);

    function toggle(id) {
        const el = document.getElementById('event_' + id);
        if (el) el.classList.toggle('event-open');
    }

    const formatarHorario = (horario) => {
        if (!horario) return "";
        return horario.slice(0, 5);
    };

    return (
        <div className="page">
            <Header />
            <main style={{ flex: 1, padding: '40px 20px' }}>
                <div style={{ maxWidth: 820, margin: '0 auto' }}>
                    <h2 className="section-title color_3 text-center">{t.agenda_title}</h2>
                    <p className="text-center mb-30" style={{ color: 'var(--color-beige)', fontWeight: 600 }}>
                        {t.agenda_subtitle}
                    </p>

                    {loading && <div className="loader-page"><div className="bt-spinner"></div></div>}

                    {!loading && events.length === 0 && (
                        <div className="text text-center mt-50">
                            <strong>{language === 'en' ? 'COMING SOON' : 'EM BREVE'}</strong>
                        </div>
                    )}

                    {events.map(group => (
                        <div key={group.id} className="event-box" style={{ maxWidth: '100%', width: '100%' }}>
                            <div className="event-container">
                                <div className="event-title">
                                    <LuCalendarDays />
                                    <span>{language === 'en' ? group.title_en : group.title}</span>
                                </div>
                            </div>
                            {group.items.map(ev => (
                                <div key={ev.id} className="event-content dont-click">
                                    <div className={`event-hour ${language}`}>
                                        {ev.time_start === ev.time_end
                                            ? <span>{formatarHorario(ev.time_start)}</span>
                                            : <span>{formatarHorario(ev.time_start)} - {formatarHorario(ev.time_end)}</span>
                                        }
                                    </div>
                                    <div className="event-wrapper">
                                        <div
                                            className={`event-content-wrapper ${(ev.description || ev.panel) ? 'has-open' : ''}`}
                                            onClick={() => (ev.description || ev.panel) && toggle(ev.id)}
                                        >
                                            <div className="event-subtitle" dangerouslySetInnerHTML={{ __html: language === 'en' ? ev.title_en : ev.title }} />
                                            {(ev.description || ev.panel) && (
                                                <div id={`event_${ev.id}`} className="event-close">
                                                    {ev.description && <div className={`event-description ${ev.panel ? 'event-border-end' : ''}`} dangerouslySetInnerHTML={{ __html: language === 'en' ? ev.description_en : ev.description }} />}
                                                    {ev.panel && <div className="event-description text-panel" dangerouslySetInnerHTML={{ __html: language === 'en' ? ev.panel_en : ev.panel }} />}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}
